import { WarningAmber } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import ModalComponent from 'components/ModalComponent';
import { AppContext } from 'context/AppContextProvider';
import { ReactElement, useContext, useEffect, useState } from 'react';
import { ENDPOINT_ALARM_CENTRAL_EVENT } from 'services/AlarmCentralService';
import { useGetAlarmCentralByIdAsync } from 'services/AlarmCentralService/hooks/useMutations';
import { IAlarmCentralEventProps } from 'services/AlarmCentralService/Virtual/types';
import { getStreamByEndpointAsync } from 'services/Events';

const PanicAlarmCentralPopupComponent = () => {
  const { audioRef } = useContext(AppContext);
  const [isOpenPanicDialog, setIsOpenPanicDialog] = useState(false);
  const [panicInfoElement, setPanicInfoElement] = useState<ReactElement>(<></>);

  const { mutateAsync: mutateGetAlarmCentralByIdAsync } =
    useGetAlarmCentralByIdAsync();
  const [isFirstAlarmCentralEvent, setIsFirstAlarmCentralEvent] =
    useState(true);
  const [alarmCentralEvents, setAlarmCentralEvents] = useState<
    IAlarmCentralEventProps[]
  >([]);
  /*useEffect(() => {
    getStreamByEndpointAsync(
      ENDPOINT_ALARM_CENTRAL_EVENT,
      setAlarmCentralEvents,
      { pageNumber: 1, pageSize: 1 },
    );
  }, []);*/

  useEffect(() => {
    if (alarmCentralEvents.length > 0) {
      if (
        alarmCentralEvents[0].eventType == 'PANIC' &&
        !isFirstAlarmCentralEvent
      ) {
        audioRef.current.play().catch((e: any) => {
          console.error('Erro ao tentar tocar a sirene:', e);
        });
        mutateGetAlarmCentralByIdAsync(alarmCentralEvents[0].alarmCentralId, {
          onSuccess: (val) => {
            setIsOpenPanicDialog(true);
            setPanicInfoElement(
              <>
                Acionado via{' '}
                {alarmCentralEvents[0].zone === '120'
                  ? 'Teclado '
                  : 'Controle Remoto'}{' '}
                ({val.name})
                <br />
                {new Date(alarmCentralEvents[0].createdAt).toLocaleString(
                  'pt-BR',
                )}
              </>,
            );
          },
        });
      }
      setIsFirstAlarmCentralEvent(false);
    }
  }, [alarmCentralEvents]);
  return (
    <ModalComponent
      cardContainerStyle={{
        backgroundColor: 'red',
        animation: 'blink 1s infinite',
      }}
      isOpen={isOpenPanicDialog}
      onClose={() => {
        setIsOpenPanicDialog(false);
        audioRef.current!.pause();
      }}
    >
      <Box
        sx={{
          display: 'flex',
          textAlign: 'center',
          width: '100%',
          padding: 2,
          flexDirection: 'column',
          justifyContent: 'center',
        }}
      >
        <Box>
          <Typography variant="h4" style={{ fontWeight: 'bold' }}>
            ALARME DE PÂNICO RECEBIDO
          </Typography>
        </Box>
        <Box>
          <WarningAmber sx={{ fontSize: 400 }} />
        </Box>

        {panicInfoElement}
      </Box>
    </ModalComponent>
  );
};

export default PanicAlarmCentralPopupComponent;
